module.exports = __webpack_public_path__ + "static/media/checked.9dbbb312.png";